var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forgot-complete"},[_c('div',{staticClass:"auth-form__title"},[_vm._v(" Thank You! ")]),_c('div',{staticClass:"auth-form__subtitle"},[_vm._v(" Please check your email. We have sent the recovery link ")])])
}]

export { render, staticRenderFns }